import { render, staticRenderFns } from "./WalletAddedModal.vue?vue&type=template&id=3ba70149&"
import script from "./WalletAddedModal.vue?vue&type=script&lang=ts&"
export * from "./WalletAddedModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports